import { render, staticRenderFns } from "./ItemFileEdit.vue?vue&type=template&id=02728959&scoped=true&"
import script from "./ItemFileEdit.vue?vue&type=script&lang=js&"
export * from "./ItemFileEdit.vue?vue&type=script&lang=js&"
import style0 from "./ItemFileEdit.vue?vue&type=style&index=0&id=02728959&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02728959",
  null
  
)

export default component.exports